import { render, staticRenderFns } from "./PerfumeSearch.vue?vue&type=template&id=4634c51e&scoped=true&"
import script from "./PerfumeSearch.vue?vue&type=script&lang=js&"
export * from "./PerfumeSearch.vue?vue&type=script&lang=js&"
import style0 from "./PerfumeSearch.vue?vue&type=style&index=0&id=4634c51e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634c51e",
  null
  
)

export default component.exports